<template>
  <div class="space-video video" v-if="this.id_video !== ''">
    <vimeo-player
      ref="player"
      :video-id="this.id_video"
      v-on:ended="videoEnded()"
      v-on:timeupdate="timeupdate"
      @ready="onReady"
    ></vimeo-player>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import axios from "axios";
import vueVimeoPlayer from "vue-vimeo-player";
export default {
  name: "cardVimeo",
  components: {
    vueVimeoPlayer
  },
  created() {},
  data() {
    return {
      options: {},
      playerReady: true,
      progressUpload: false,
      resources: [],
      verify: false
    };
  },
  computed: {
    ...mapState,
    ...mapGetters({
      idCourse: "course/idCourse",
      id_video: "course/id_video",
      id_resource: "course/id_resource",
      id_lesson: "course/id_lesson",
      type_resource: "course/type_resource"
    }),
    userId() {
      return JSON.parse(localStorage.getItem("user"));
    }
  },
  methods: {
    onReady() {
      this.playerReady = true;
    },
    play() {
      this.$refs.player.play();
    },
    pause() {
      this.$refs.player.pause();
    },
    timeupdate(data) {
      if (data.percent >= 0.9 && this.verify === false) {
        if (this.type_resource === 1 || this.type_resource === 2) {
          var url = "/api/v1/course/addUserResource";
          var token = (axios.defaults.headers.common["Authorization"] =
            "Bearer " + localStorage.getItem("a_t"));
          axios
            .post(url, {
              headers: {
                token
              },
              mounted_course_id: localStorage.getItem("mountedCourseId"),
              user_id: this.userId.id,
              /*resourcesLesson: this.resourcesLesson,*/
              resource_id: this.id_resource,
              lesson_id: this.id_lesson
            })
            .then(response => {
              this.progressUpload = false;
              var total = 0;

              var progress = response.data;
              Object.keys(progress).forEach(function(key) {
                total = total + Number(progress[key].value);
              });

              /*this.total_progress = total;*/
              this.$store.commit("total_progress", total.toFixed(0));

              this.verify = true;
            });
        }
      }
    },
    videoEnded() {
      this.$store.commit("course/video_finish", true);
      this.$store.commit("course/vimeo_Id", this.id_video);
    },

    getOtherResources: function() {
      var url = "/api/v1/course/getOtherResource";
      var token = (axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("a_t"));
      axios
        .post(url, {
          headers: {
            token
          },
          lessons_id: id_lesson
        })
        .then(response => {
          this.resources = response.data;
        });
    }
  }
};
</script>
<style scoped>
.space-video {
  padding-top: 10px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100% !important;
}
.video {
  width: 100%;
  min-height: 100%;
}
@media screen and (max-width: 1024px) {
  .space-video {
    max-width: 280px;
  }
}
</style>
